export enum UserStatus {
    SUSPENDED,
    ACTIVE
  }  